import { SortState } from '../types';

export const getNextSortDirection = (currentSortState: SortState | undefined, columnKey: string): SortState => {
  if (currentSortState?.key !== columnKey) {
    return { key: columnKey, direction: 'asc' };
  }

  if (currentSortState.direction === 'asc') {
    return { key: columnKey, direction: 'desc' };
  }

  return null;
};

export const getAriaSortValue = (
  sortState: SortState | undefined,
  columnKey: string,
  sortable: boolean,
): 'ascending' | 'descending' | 'none' | undefined => {
  if (!sortable) {
    return undefined;
  }

  if (sortState?.key !== columnKey) {
    return 'none';
  }

  return sortState.direction === 'asc' ? 'ascending' : 'descending';
};
